
















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { ILabelValue } from '@/interfaces/generic'
import { IColumnHeader, AVAILABLE_FIELDS_TRACK_SELECTOR } from '@/constants'

@Component({})
export default class ColumnVisibility extends Vue {
  @Prop()
  value: IColumnHeader[]

  selected: IColumnHeader[] = this.value

  get availableFields(): ILabelValue[] {
    return AVAILABLE_FIELDS_TRACK_SELECTOR
  }

  updateSelected(v: IColumnHeader[]) {
    this.selected = v
  }

  emitAutofitColumns() {
    this.$emit('autofitColumns')
  }

  @Watch('selected')
  emitSelected(selected: IColumnHeader[]) {
    const values: IColumnHeader[] = JSON.parse(JSON.stringify(AVAILABLE_FIELDS_TRACK_SELECTOR))

    for (const v of values) {
      v.visible = false
    }

    selected.forEach(x => {
      const v = values.find(y => y.value === x.value)

      if (v) {
        v.visible = true
      } else {
        values.push({
          label: x.label,
          value: x.value,
          visible: true
        })
      }
    })

    this.$emit('input', values)
  }
}
